import { NgModule } from '@angular/core';
import { WarningMessageComponent } from 'app/utils/warning-message/warning-message.component';
import { CommonModule } from '@angular/common';
import { MessageComponent } from './message/message.component';
import { MatIconModule } from '@angular/material/icon';
import { WholePageErrorComponent } from './whole-page-error/whole-page-error.component';

const publicDirectives = [
    WarningMessageComponent,
    MessageComponent,
    WholePageErrorComponent,
];

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
    ],
    declarations: [
        ...publicDirectives,
    ],
    exports: [
        ...publicDirectives,
    ],
})
export class I360WarningMessageModule {}
